import { compose } from '@reduxjs/toolkit';
import { ComponentType } from 'react';
import { withTranslation } from 'react-i18next';

import PrivacyPolicy from './PrivacyPolicy.layout';


const decorate = compose<ComponentType>(
    withTranslation('privacyPolicy'),
);

export default decorate(PrivacyPolicy);
